import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForIndividualSubmittedResponsesRPC } from "./getPresignedDownloadUrlForIndividualSubmittedResponsesRPC";

export class GetPresignedDownloadURLForIndividualSubmittedResponsesRPCClientImpl extends GetPresignedDownloadURLForIndividualSubmittedResponsesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForIndividualSubmittedResponsesRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForIndividualSubmittedResponsesRPC.Response, GetPresignedDownloadURLForIndividualSubmittedResponsesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/GetPresignedDownloadURLForIndividualSubmittedResponses",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForIndividualSubmittedResponsesRPC.ResponseDTO,
      GetPresignedDownloadURLForIndividualSubmittedResponsesRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForIndividualSubmittedResponsesRPC.Response,
      GetPresignedDownloadURLForIndividualSubmittedResponsesRPC.Errors.Errors
    >(
      response,
      "respondent/GetPresignedDownloadURLForIndividualSubmittedResponses",
      GetPresignedDownloadURLForIndividualSubmittedResponsesRPC.Response.fromDTO,
      GetPresignedDownloadURLForIndividualSubmittedResponsesRPC.Errors.fromDTO
    );
  }
}
